/*
 * External libraries to be pulled in as script tags for CDN usage.
 */
import remote from '@corefact/toolchain/polyfills/remote';

let mode = !process.env.ISDEV ? 'production' : 'development',
    min = !process.env.ISDEV ? '.min' : '',
    { scripts, stylesheets } = remote(ENVConfig, mode, min);

export default {
    // Remote JavaScript scripts.
    javascripts: {
        enabled: true,
        scripts: [
            ...scripts,
            // Optional remote libraries.
            {
                //  enabled: false,
                src: 'https://cdn.jsdelivr.net/npm/rollbar@latest/dist/rollbar.umd.min.js',
                crossorigin: '',
                enabledIf: () => ENVConfig.rollbar?.accessToken && !window.rollbar,
                onload: () => {
                    window.ErrorReporter = new rollbar({
                        ...{
                            captureUncaught: true,
                            captureUnhandledRejections: true,
                        },
                        ...ENVConfig.rollbar,
                    });
                    if (window.ErrorReporter instanceof window.rollbar) {
                        window.ErrorReporter.warn = (...args) => window.ErrorReporter.warning.apply(window.ErrorReporter, args);
                        window.ErrorReporter.trace = (...args) => window.ErrorReporter.critical.apply(window.ErrorReporter, args);
                    } else {
                        console.warn('WARNING: Rollbar not configured; using console.* methods!');
                    }
                },
            },
        ],
    },
    // Remote CSS stylesheets/webfonts.
    stylesheets: {
        enabled: true,
        sheets: [
            ...stylesheets,
            {
                rel: 'stylesheet',
                href: 'https://use.fontawesome.com/releases/v5.7.2/css/all.css',
            },
        ],
    },
};
